var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-menu-wrapper",attrs:{"id":"overlay-menu"}},[_c('div',{staticClass:"overlay-menu-inner"},[_c('div',{staticClass:"overlay-menu text-center"},[_c('OverlayNav')],1),_c('button',{staticClass:"page-close",on:{"click":function($event){return _vm.toggleClass('removeClass', 'active')}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }